import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
/**
 * Prevents additional margin in markdown for a single child item.
 */
const MuiMarkdownParagraph = styled(Typography)({
    name: "MuiMarkdownParagraph",
    component: "p",
}, ({ theme }) => ({
    "&:not(:only-child)": {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));
/**
 * Mui styled divider has no margin by default but consistent styling.
 */
const MuiMarkdownDivider = styled(Divider)({
    name: "MuiMarkdownDivider",
}, ({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
}));
export const MuiMarkdownComponents = {
    p: MuiMarkdownParagraph,
    hr: MuiMarkdownDivider,
    a: Link,
};
//# sourceMappingURL=MuiMarkdownComponents.js.map